export default __webpack_public_path__ + "static/media/closebottle.711e74a3.svg";